import api, { getRequest, postRequest } from './client';
import config from "environment";
import { CreateVibeProcessPayload, CreateVibeProcessWorkflowPayload, VibeProcess, Workflow } from "winslow-core";
import { StartVibeProcessPayload } from 'winslow-core';

const { baseApi } = config;

export const apiCreateVibeProcess = async (
    payload: CreateVibeProcessPayload
): Promise<VibeProcess | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateVibeProcess");
    // const response = await api.post(`${baseApi}/workflows/vibe/create`, payload);
    // return response.data.data;
};
   
export const apiGetVibeProcess = async (vibeProcessId: string): Promise<VibeProcess | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/${vibeProcessId}`;
  return await getRequest(fetchURL, "API/apiGetVibeProcess");
}; 

export const apiGetVibeProcessesForWorkspace = async (workspaceId: string): Promise<VibeProcess[] | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetVibeProcessesForWorkspace");
};

export const apiCreateVibeProcessWorkflow = async (payload: CreateVibeProcessWorkflowPayload): Promise<JSON | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/create-workflow`;
  return await postRequest(fetchURL, payload, "API/apiCreateVibeProcessWorkflow");
};

export const apiUpdateVibeProcess = async (vibeProcessId: string, payload: any): Promise<VibeProcess | null> => {
  try {
  const response = await api.put(`${baseApi}/workflows/vibe/${vibeProcessId}`, payload);
  return response.data.data;
  } catch (error) {
    console.error('Error updating vibe process:', error);
    return null;
  }
};

export const apiStartVibeProcess = async (payload: StartVibeProcessPayload): Promise<VibeProcess | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/start-workflow`;
  return await postRequest(fetchURL, payload, "API/apiStartVibeProcess");
};

export const apiProcessWorkflowActiveNodes = async (workflowId: string): Promise<Workflow | null> => {
  const fetchURL = `${baseApi}/workflows/vibe/process-active-nodes/${workflowId}`;
  return await getRequest(fetchURL, "API/apiProcessWorkflowActiveNodes");
};

export const apiGetWorkflow = async (workflowId: string): Promise<Workflow | null> => {
  const fetchURL = `${baseApi}/workflows/${workflowId}`;
  return await getRequest(fetchURL, "API/apiGetWorkflow");
};

export const apiGetWorkflowsForWorkspace = async (workspaceId: string): Promise<Workflow[] | null> => {
  const fetchURL = `${baseApi}/workflows/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkflowsForWorkspace");
};

export const apiUpdateWorkflowStatus = async (workflowId: string, status: string): Promise<Workflow | null> => {
  try {
    const response = await api.put(`${baseApi}/workflows/${workflowId}/status`, { status });
    return response.data.data;
  } catch (error) {
    console.error('Error updating workflow status:', error);
    return null;
  }
};

export const apiDeleteWorkflow = async (workflowId: string): Promise<Workflow | null> => {
  try {
    const response = await api.delete(`${baseApi}/workflows/${workflowId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting workflow:', error);
    return null;
  }
};